import { useEffect, useContext } from "react";

import PermissionContext from "../../../context/PermissionContext";
import DrawerContext from "../../../context/DrawerContext";
import AutoLogout from "../../../utils/useAutoLogout";
import LipidStocksContext from "../../../context/materialcapture/LipidStocksContext";

import SideDrawer from "../../../components/layout/SideDrawer";
import SuccessAlert from "../../../components/layout/SuccessAlert";
import Loader from "../../../components/layout/Loader";
import ErrorModal from "../../../components/layout/ErrorModal";
import TopBarWithBack from "../../../components/layout/TopBarWithBack";
import LipidStocksForm from "../../../components/materialscapture/LipidStocksForm";

const LipidStocksEditPage = () => {
  const { permisionsList, checkUserPermission } = useContext(PermissionContext);
  const { drawerValue, setDrawerValue } = useContext(DrawerContext);
  const { apiRes, setApiRes, setLipidStocksId } = useContext(LipidStocksContext);

  const backURL = '/lipid-stocks';

  useEffect(() => {
    if(permisionsList.length > 0) checkUserPermission(['Materials Capture-Lipid Stocks']);
  }, [permisionsList]);

  useEffect(() => {
    const docUrIArr = window.location.href.split('/');
    setLipidStocksId(docUrIArr[docUrIArr.length - 1]);
  }, []);

  return(
    <AutoLogout>
      <SideDrawer drawerValue={drawerValue} setDrawerValue={setDrawerValue} />
      {apiRes.loading && <Loader />}
      <div className="mainContainer" style={{ marginLeft: drawerValue.drawerWidth }}>
        {apiRes.showAlert && <SuccessAlert apiRes={apiRes} setApiRes={setApiRes} />}
        <TopBarWithBack title={'Lipid Stocks Edit'} backURL={backURL} />
        <LipidStocksForm />

        <ErrorModal apiRes={apiRes} setApiRes={setApiRes} />
      </div>
    </AutoLogout>
  );
};

export default LipidStocksEditPage;